import React from 'react';
import { ExternalLink, GitMerge, History, Layers } from 'lucide-react';
import { Button } from '../ui/button';
import ClienteHistorial from './ClienteHistorial';
import PreviousCasesBanner from './PreviousCasesBanner';
import CasoComparativaTab from './CasoComparativaTab';
import InformeVinculacion from './InformeVinculacion';
import { digitos } from './episodioUtils';

const Seccion = ({ titulo, icono: Icono, testid, children }) => (
  <section className="rounded-xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <h3 className="mb-4 flex items-center gap-2 text-sm font-semibold text-slate-800"><Icono size={15} className="text-slate-500" /> {titulo}</h3>
    {children}
  </section>
);

// F4: historial del cliente, casos anteriores (comparativa y timeline histórico) e informe de vinculación.
export const CasoClienteTab = ({ caso, navigate, score, onIncorporated }) => {
  const cuit = [digitos(caso.cuit), digitos(caso.cliente_key)].find((x) => x.length === 11);
  const anteriores = caso.casos_anteriores?.length > 0;
  return (
    <div className="space-y-5" data-testid="caso-cliente-tab">
      {cuit && (
        <div className="flex items-center justify-between rounded-xl border border-sky-200 bg-sky-50/60 px-4 py-3">
          <p className="text-sm text-sky-900">{caso.nombre_padron || 'Cliente'} · <span className="font-mono">{cuit}</span></p>
          <Button size="sm" variant="outline" className="gap-1 bg-white" onClick={() => navigate(`/m/clientes/cliente/${cuit}`)} data-testid="caso-abrir-ficha-cliente">
            <ExternalLink size={14} /> Abrir ficha del cliente
          </Button>
        </div>
      )}
      <Seccion titulo="Casos del cliente" icono={History} testid="caso-cliente-historial">
        <ClienteHistorial caseId={caso.id} casoActual={caso} navigate={navigate} score={score} />
      </Seccion>
      {anteriores && (
        <Seccion titulo="Casos anteriores" icono={Layers} testid="caso-cliente-anteriores">
          <PreviousCasesBanner casos={caso.casos_anteriores} caseId={caso.id} contextoIncorporado={caso.contexto_incorporado || []}
            onIncorporated={onIncorporated} titulo={`${caso.casos_anteriores.length} caso(s) anterior(es) del cliente`} />
          <div className="mt-4 overflow-hidden rounded-lg border border-slate-200">
            <CasoComparativaTab caso={caso} casosAnteriores={caso.casos_anteriores} onIncorporated={onIncorporated} />
          </div>
        </Seccion>
      )}
      {caso.es_unificado && caso.informe_vinculacion && (
        <Seccion titulo="Informe de vinculación" icono={GitMerge} testid="caso-cliente-vinculacion">
          <InformeVinculacion caso={caso} navigate={navigate} />
        </Seccion>
      )}
    </div>
  );
};

export default CasoClienteTab;
